/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum LanguageTranslation {
  Danish = "Danish",
  English = "English",
  French = "French",
  German = "German",
  Italian = "Italian",
  Polish = "Polish",
  Portuguese = "Portuguese",
  Russian = "Russian",
  SimplifiedChinese = "SimplifiedChinese",
  Spanish = "Spanish",
  Swedish = "Swedish",
  TraditionalChinese = "TraditionalChinese",
}

export enum MediaType {
  Photo = "Photo",
  Video = "Video",
}

export enum NotificationType {
  Close = "Close",
  Message = "Message",
  Progress = "Progress",
}

export enum OrderDirection {
  ASC = "ASC",
  DESC = "DESC",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
